import { render, staticRenderFns } from "./AdministrativeOblasts.vue?vue&type=template&id=6a5828a7&"
import script from "./AdministrativeOblasts.vue?vue&type=script&lang=js&"
export * from "./AdministrativeOblasts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports